export default "__VITE_ASSET__DVG$wCNI__"